import { FC } from 'react';
import {
  CustomView,
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';

import preview from './preview/builder_system_prototype/builder_system_prototype.png';
import thumbnail from './preview/builder_system_prototype/builder_system_prototype_thumbnail.png';
import { SystemPrototype } from '@agilelab/plugin-wb-system-prototype-common';

CustomViewPages.register({
  id: 'builder_system_prototype',
  meta: {
    label: 'System Prototype Page',
    category: CustomViewPageCategory.BUILDER,
    typeId: { type: CustomViewTypeIdType.SYSTEM_PROTOTYPE },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  function: function SystemPrototypeDetailsCustomView() {
    return (
      <CustomViewComponent type="grid_list">
        <CustomViewComponent
          type="system_prototype_section_card"
          title="Value Proposition"
          section="Value Proposition"
        >
          <CustomViewComponent type="card_content">
            <CustomViewComponent type="hbox" responsive>
              <CustomViewComponent type="container" size={4}>
                <CustomViewComponent label="Owner" type="string" path="owner" />
                <CustomViewComponent
                  label="Created At"
                  type="date"
                  path="created_at"
                />
                <CustomViewComponent
                  label="Status"
                  type="system_prototype_status"
                  path="status"
                />
                <CustomViewComponent
                  label="Purpose"
                  type="string"
                  path="purpose"
                  colSpan="4"
                />
                <CustomViewComponent
                  label="Description"
                  type="string"
                  path="description"
                  colSpan="4"
                />
              </CustomViewComponent>
              <CustomViewComponent type="group" borderLeft size={1}>
                <CustomViewComponent
                  type="string"
                  path="systemPrototypeTypeDisplayName"
                  label="Type"
                  colSpan="4"
                />
                <CustomViewComponent
                  type="string"
                  path="domainDisplayName"
                  label="Domain"
                  colSpan="4"
                />
                <CustomViewComponent
                  label="Updated At"
                  type="date"
                  path="updated_at"
                  colSpan="4"
                />
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
          <CustomViewComponent type="card_content">
            <CustomViewComponent type="container" borderTop>
              <CustomViewComponent
                label="Key Results"
                path="parameters.Value Proposition.keyResults"
                type="badge"
                colSpan="4"
                displayValue="{{name}}"
              />
            </CustomViewComponent>
          </CustomViewComponent>
        </CustomViewComponent>
        <CustomViewComponent
          type="system_prototype_section_card"
          title="Product Discovery"
          section="Product Discovery"
        >
          <CustomViewComponent
            type="new_root"
            path="parameters.Product Discovery"
          >
            <CustomViewComponent type="card_content">
              <CustomViewComponent type="hbox" responsive>
                <CustomViewComponent type="container" size={4}>
                  <CustomViewComponent
                    type="string"
                    label="Expected Usage"
                    path="expectedUsage"
                  />
                  <CustomViewComponent
                    type="string"
                    label="Desired Time To Market"
                    path="desiredTimeToMarket"
                  />
                  <CustomViewComponent
                    type="stars"
                    label="Importance"
                    path="importance"
                  />
                  <CustomViewComponent type="string" label="POC" path="poc" />
                  <CustomViewComponent
                    type="string"
                    label="Feasibility"
                    path="feasibility"
                    colSpan="4"
                  />
                  <CustomViewComponent
                    type="string"
                    label="Desirability"
                    path="desirability"
                    colSpan="4"
                  />
                  <CustomViewComponent
                    type="string"
                    label="Blockers"
                    path="blockers"
                    colSpan="4"
                  />
                  <CustomViewComponent
                    type="string"
                    label="Pre-conditions"
                    path="preConditions"
                    colSpan="4"
                  />
                </CustomViewComponent>
                <CustomViewComponent type="group" borderLeft size="0 0 auto">
                  <CustomViewComponent
                    type="system_prototype_blueprint"
                    path="blueprint"
                  />
                </CustomViewComponent>
              </CustomViewComponent>
            </CustomViewComponent>
            <CustomViewComponent type="card_content">
              <CustomViewComponent type="container" borderTop>
                <CustomViewComponent
                  label="Success Metrics"
                  path="successMetrics"
                  type="badge"
                  colSpan="4"
                  displayValue="{{name}}"
                />
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
        </CustomViewComponent>
        <CustomViewComponent
          type="system_prototype_section_card"
          title="Information Prototyping"
          section="Information Prototyping"
        >
          <CustomViewComponent
            type="system_prototype_information_prototyping"
            dataSourcesPath="parameters.Information Prototyping.dataSources"
            businessConceptsPath="parameters.Information Prototyping.businessConcepts"
          />
        </CustomViewComponent>
        <CustomViewComponent
          type="system_prototype_section_card"
          title="Cost Estimation"
          section="Cost Estimation"
        >
          <CustomViewComponent
            type="new_root"
            path="parameters.Cost Estimation"
          >
            <CustomViewComponent type="card_content">
              <CustomViewComponent type="hbox">
                <CustomViewComponent type="container">
                  <CustomViewComponent
                    type="cost_display"
                    label="Cost Estimation CAPEX"
                    path="costEstimationCapex"
                    currency="EUR"
                    locale="it-IT"
                    colSpan="4"
                    align="center"
                  />
                </CustomViewComponent>
                <CustomViewComponent type="container" borderLeft>
                  <CustomViewComponent
                    type="cost_display"
                    label="Monthly IT Resources Cost"
                    path="monthlyITResourcesCost"
                    currency="EUR"
                    locale="it-IT"
                    cadency="month"
                    colSpan="4"
                    align="center"
                  />
                </CustomViewComponent>
                <CustomViewComponent type="container" borderLeft>
                  <CustomViewComponent
                    type="cost_display"
                    label="Monthly Mantenance Effort"
                    path="monthlyMaintenanceEffort"
                    currency="EUR"
                    locale="it-IT"
                    cadency="month"
                    colSpan="4"
                    align="center"
                  />
                </CustomViewComponent>
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
        </CustomViewComponent>
      </CustomViewComponent>
    );
  },
});

export type SystemPrototypeDetailsCustomViewProps = {
  data: SystemPrototype;
  type?: string;
  template?: string;
};

export const SystemPrototypeDetailsCustomView: FC<
  SystemPrototypeDetailsCustomViewProps
> = ({ data, type }) => {
  return <CustomView id="builder_system_prototype" data={data} typeId={type} />;
};
